var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from '../base';
import { DatasetProvider } from '../dataset';
import { AssetListingProvider } from '../asset_listing';
import { ClassProvider } from '../class';
import { AnomalyStatsService } from './anomaly-stats.service';
import { FrameProvider } from '../frame';
export var EvaluatePageTab;
(function (EvaluatePageTab) {
    EvaluatePageTab["WorkingBrain"] = "WorkingBrain";
    EvaluatePageTab["StaticBrain"] = "StaticBrain";
    EvaluatePageTab["HiFiBrain"] = "HiFiBrain"; // Used for Anomaly Hi-Fi brains
})(EvaluatePageTab || (EvaluatePageTab = {}));
export var ExpandedPageMode;
(function (ExpandedPageMode) {
    ExpandedPageMode["NONE"] = "none";
    ExpandedPageMode["VALIDATION_SET"] = "validationSet";
    ExpandedPageMode["VALIDATION_RESULTS"] = "validationResults";
    ExpandedPageMode["VALIDATION_IMAGE_DETAILS"] = "validationImageDetails";
    ExpandedPageMode["WORKSPACE"] = "workspace";
})(ExpandedPageMode || (ExpandedPageMode = {}));
var EvaluateBrainProvider = /** @class */ (function (_super) {
    __extends(EvaluateBrainProvider, _super);
    function EvaluateBrainProvider(datasetProvider, assetListingProvider, classProvider, anomalyStatsService, frameProvider) {
        var _this = _super.call(this) || this;
        _this.datasetProvider = datasetProvider;
        _this.assetListingProvider = assetListingProvider;
        _this.classProvider = classProvider;
        _this.anomalyStatsService = anomalyStatsService;
        _this.frameProvider = frameProvider;
        return _this;
    }
    /**
     * Individual variable getters/setters
     */
    EvaluateBrainProvider.prototype.getRecognitionFrames = function () {
        return this.recognitionFrames;
    };
    EvaluateBrainProvider.prototype.pageHasRecognitionFrames = function () {
        return this.recognitionFrames && this.recognitionFrames.length > 0;
    };
    EvaluateBrainProvider.prototype.getFilteredRecognitionFrames = function () {
        return this.filteredRecognitionFrames;
    };
    EvaluateBrainProvider.prototype.getClassesTable = function () {
        return this.classesTable;
    };
    EvaluateBrainProvider.prototype.getEvaluateImageDetailsPageNumber = function () {
        return this.evaluateImageDetailsPageNumber;
    };
    EvaluateBrainProvider.prototype.setEvaluateImageDetailsPageNumber = function (page) {
        this.evaluateImageDetailsPageNumber = page;
    };
    EvaluateBrainProvider.prototype.cleanUpFilterState = function () {
        this.filteringClassID = '';
        this.filteringResults = '';
    };
    EvaluateBrainProvider.prototype.fetchRecognitionFrames = function (datasetIdentifier, brainVersionType, isTestSet) {
        if (isTestSet === void 0) { isTestSet = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, datasetClassNameMap_1, nothingIKnowClass_1, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!isTestSet) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.frameProvider.getTestRecognitionFrames(datasetIdentifier, 0, 9999)];
                    case 1:
                        _a.recognitionFrames = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.frameProvider.getValidationRecognitionFrames(datasetIdentifier, 0, 9999, brainVersionType)];
                    case 3:
                        _b.recognitionFrames = _c.sent();
                        _c.label = 4;
                    case 4:
                        this.classesTable = new Map();
                        datasetClassNameMap_1 = this.classProvider.getDatasetClassNameMap(datasetIdentifier);
                        nothingIKnowClass_1 = this.classProvider.getNothingIKnowClass(datasetIdentifier);
                        this.recognitionFrames.forEach(function (asset) {
                            if (!_this.classesTable.has(asset.actualClass) && datasetClassNameMap_1[asset.actualClass]) {
                                _this.classesTable.set(asset.actualClass, datasetClassNameMap_1[asset.actualClass]);
                            }
                            if (!_this.classesTable.has(asset.predictedClass) && datasetClassNameMap_1[asset.predictedClass]) {
                                _this.classesTable.set(asset.predictedClass, datasetClassNameMap_1[asset.predictedClass]);
                            }
                            if (isTestSet &&
                                !asset.actualClass &&
                                _this.classProvider.isClassNothingIKnow(asset.predictedClass, false)) {
                                _this.classesTable.set(nothingIKnowClass_1.name, nothingIKnowClass_1);
                            }
                        });
                        this.filteredRecognitionFrames = this.assetListingProvider.applyRecognitionFramesFilter(this.recognitionFrames, this.filteringClassID, this.filteringResults, this.classesTable);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        throw error_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EvaluateBrainProvider.prototype.onNormalThresholdChanged = function (newValue, datasetIdentifier) {
        var _this = this;
        var dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
        if (!dataset) {
            return;
        }
        var tempRecognitionFrames = this.recognitionFrames.map(function (v) {
            var predictedClass = v.normalScore == null || v.normalScore >= newValue ? 'Normal' : 'Anomaly';
            var testOutcome = _this.anomalyStatsService.convertResultNameToInitials(_this.anomalyStatsService.getSingleAnomalyTestOutcome(v.actualClass, predictedClass, dataset.truePositivePreference));
            return {
                anomalyOverlaySignedUrl: v.anomalyOverlaySignedUrl,
                assetIdentifier: v.assetIdentifier,
                normalScore: v.normalScore,
                name: v.name,
                prefix: v.prefix,
                actualClass: v.actualClass,
                predictedClass: predictedClass,
                signedThumbnailUrl: v.signedThumbnailUrl,
                testOutcome: testOutcome
            };
        });
        this.recognitionFrames = tempRecognitionFrames;
    };
    EvaluateBrainProvider.prototype.updateFilteringClassForRecognitionFrames = function (newClassId) {
        this.filteringClassID = newClassId;
        this.filteredRecognitionFrames = this.assetListingProvider.applyRecognitionFramesFilter(this.recognitionFrames, this.filteringClassID, this.filteringResults, this.classesTable);
    };
    EvaluateBrainProvider.prototype.updateFilteringResultsForRecognitionFrames = function (newResults) {
        this.filteringResults = newResults;
        this.filteredRecognitionFrames = this.assetListingProvider.applyRecognitionFramesFilter(this.recognitionFrames, this.filteringClassID, this.filteringResults, this.classesTable);
    };
    EvaluateBrainProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DatasetProvider,
            AssetListingProvider,
            ClassProvider,
            AnomalyStatsService,
            FrameProvider])
    ], EvaluateBrainProvider);
    return EvaluateBrainProvider;
}(BaseProvider));
export { EvaluateBrainProvider };
//# sourceMappingURL=evaluate_brain.js.map


// WEBPACK FOOTER //
// ./src/providers/evaluate_brain/evaluate_brain.ts.pre-build-optimizer.js